import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["responsive", "topBottom", "leftRight", "top", "right", "bottom", "left", "type", "children"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Spacing/Spacing.js",
    _this = this;

import React from 'react';
import { SpacingStyle } from './style';

var Spacing = function Spacing(_ref) {
  var _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? true : _ref$responsive,
      _ref$topBottom = _ref.topBottom,
      topBottom = _ref$topBottom === void 0 ? 0 : _ref$topBottom,
      _ref$leftRight = _ref.leftRight,
      leftRight = _ref$leftRight === void 0 ? 0 : _ref$leftRight,
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? topBottom : _ref$top,
      _ref$right = _ref.right,
      right = _ref$right === void 0 ? leftRight : _ref$right,
      _ref$bottom = _ref.bottom,
      bottom = _ref$bottom === void 0 ? topBottom : _ref$bottom,
      _ref$left = _ref.left,
      left = _ref$left === void 0 ? leftRight : _ref$left,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'padding' : _ref$type,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(SpacingStyle, _extends({}, rest, {
    responsive: responsive,
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    type: type,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }), children);
};

Spacing.defaultProps = {};
export default Spacing;